/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
const mdSize = {height: 11, borderRadius: 'base'}

export default {
    sizes: {
        md: {
            field: {...mdSize, px: 3},
            addon: mdSize
        }
    },
    baseStyle: {
        field: {
            _invalid: {
                borderColor: 'red.600'
            },
            _hover: {
                borderColor: 'gray.300'
            },
            _focus: {
                borderColor: 'yellow.400'
            },
            _focusVisible: {
                borderColor: 'yellow.400',
                boxShadow: 'none'
            }
        }
    },
    variants: {
        outline: (props) => ({
            field: {
                borderColor: 'gray.100',
                color: 'black',
                ...props.theme.textStyles.bookMedium,
                _invalid: {
                    borderColor: 'red.600',
                    boxShadow: '0px 0px 4px 0px #DC0A3C80'
                },
                _hover: {
                    borderColor: 'gray.300'
                },
                _focus: {
                    borderColor: 'yellow.400',
                    boxShadow: '0px 0px 3px 0px var(--chakra-colors-yellow-400)'
                },
                _focusVisible: {
                    borderColor: 'yellow.400',
                    boxShadow: 'none'
                },
                _placeholder: {
                    color: 'gray.300',
                    ...props.theme.textStyles.bookMedium
                }
            }
        }),
        filled: {
            // we use filled variant for
            // search input
            field: {
                borderColor: 'gray.600',
                backgroundColor: 'gray.100',
                _focus: {
                    backgroundColor: 'white'
                },
                _hover: {
                    backgroundColor: 'gray.100',
                    _focus: {
                        backgroundColor: 'white'
                    }
                },
                _placeholder: {
                    color: 'gray.700'
                }
            }
        }
    }
}
